import { filter, map, optimum } from '@vaaas/fpts/iter';
import { pipe } from '@vaaas/fpts/function';
import { gt, add } from '@vaaas/fpts/maths';
import { maybe } from '@vaaas/fpts/option';

export function without_file_extension(x: string): string {
    const i = x.lastIndexOf('.');
    if (i === -1)
        return x;
    else if (x.length - i > 5)
        return x;
    else
        return x.slice(0, i);
}

export function with_file_extension(x: string, extension: string): string {
    if (x.endsWith(extension))
        return x;
    else
        return x + extension;
}

function file_counter(x: string): number {
    const matches = x.match(new RegExp('\\(([0-9]+)\\)$'));
    if (!matches) return 0;
    else if (!matches[1]) return 0;
    else return parseFloat(matches[1]);
}

export function recommend_different_filename(file_name: string, existing_names: string[]): string {
    return pipe(
        existing_names,
        filter(x => x.startsWith(file_name)),
        map(file_counter),
        optimum(gt),
        maybe(0, add(1)),
        x => `${file_name} (${x})`,
    );
}

export function name_without_counter(x: string): string {
    const matches = x.match(new RegExp('^(.+) \\(([0-9]+)\\)$'));
    if (!matches)
        return x;
    else if (!matches[1])
        return x;
    else
        return matches[1];
}
